module.exports = __webpack_public_path__ + "static/media/facebook.5c652a4f.svg";